import { logClientInfo } from 'src/common/actions/logging';
import { selectHeroCarouselItems } from 'src/common/selectors/heroCarousel';
import {
  CAROUSEL_GUIDEID,
  CAROUSEL_FETCH_SKIP_MSG,
} from 'src/common/constants/heroCarousel';
import { getCustomBrowseItemsByGuideId } from './browse';

export const FETCH_CAROUSEL_ITEMS = 'FETCH_CAROUSEL_ITEMS';

export function getCarouselItemsIfNeeded() {
  return (dispatch, getState) => {
    const carouselItems = selectHeroCarouselItems(getState());
    if (!carouselItems.length) {
      return dispatch(
        getCustomBrowseItemsByGuideId(CAROUSEL_GUIDEID, FETCH_CAROUSEL_ITEMS),
      );
    }
    // log cases when not fetched
    dispatch(
      logClientInfo({ message: CAROUSEL_FETCH_SKIP_MSG, context: {} }),
    ).catch(() => {}); // no-op. Catching this in case it errors out for some reason
    return Promise.resolve(); // returning this for testing purposes
  };
}
